/**
 * PDP: defer gallery, cross-sell, and CTA until after load.
 * @version 1.0.0
 * @lastModified 2026-10-16
 */
(function () {
  const urls = window.sbProductIdleScriptUrls || [];
  if (!urls.length) return;

  let started = false;
  const loadAll = () => {
    if (started) return;
    started = true;
    urls.forEach((src) => {
      if (!src || document.querySelector(`script[src="${src}"]`)) return;
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      document.head.appendChild(script);
    });
  };

  const schedule = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadAll, { timeout: 3000 });
    } else {
      setTimeout(loadAll, 1200);
    }
  };

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
})();
